import { Component, OnInit, Inject } from '@angular/core';
import { PrinterClass } from 'src/app/domain/printerClass/printer-class';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Validators, UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-add-printer-class-dialog',
  templateUrl: './add-printer-class-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule
  ],
  styleUrls: ['./add-printer-class-dialog.component.css']
})
export class AddPrinterClassDialogComponent implements OnInit {

  // https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/RegExp
  /**
   * Names should not contain special characters and should not contain german umlauts.
   */
  nameRegexPattern = '^[a-zA-Z0-9]+?[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*?$';
  nameValidator = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(this.nameRegexPattern)
  ]);

  constructor(
    public dialogRef: MatDialogRef<AddPrinterClassDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrinterClass) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
